export default "__VITE_ASSET__CWhZYuu5__"